import React from "react";
import { Button } from "antd";
import jsPDF from "jspdf";
import { ReceiptData } from "./ViewMovementDetail";

const ReceiptPDFPrint = ({ receipt }: { receipt: ReceiptData }) => {
  const generateTicket = () => {
    // --- Configurar tamaño del papel: 80 mm x largo estimado (por ejemplo 200 mm)
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [80, 200],
    });

    let y = 10; // posición vertical inicial

    // --- ENCABEZADO
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(receipt.companyName, 40, y, { align: "center" });

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    y += 5;
    doc.text(`${receipt.pdv}`, 40, y, { align: "center" });
    y += 5;
    doc.text(receipt.companyAddress, 40, y, { align: "center" });

    y += 5;
    doc.text(`Comprobante : ${receipt.receiptId}`, 40, y, { align: "center" });
    y += 4;
    doc.text(`Fecha elaboración: ${receipt.date}`, 40, y, { align: "center" });
    y += 4;
    doc.text(`Fecha impresión: ${new Date().toLocaleString()}`, 40, y, { align: "center" });

    y += 6;
    doc.line(5, y, 75, y);

    y += 6;
    doc.text(`Vendedor: ${receipt.seller}`, 5, y);
    // --- CLIENTE
    if (receipt.customer) {
      y += 4;
      doc.text(`Cliente: ${receipt.customer}`, 5, y);
    }

    // --- DETALLE DE PRODUCTOS
    y += 6;
    doc.setFont("helvetica", "bold");
    doc.text("DETALLE ITEMS", 40, y, { align: "center" });
    doc.setFont("helvetica", "normal");
    y += 4;
    doc.line(5, y, 75, y);

    y += 6;
    receipt.items.forEach((item) => {
      doc.text(item.product, 5, y);
      y += 4;
      doc.text(
        `${item.quantity} x $${item.price.toLocaleString()}  =  $${item.total.toLocaleString()}`,
        8,
        y
      );
      y += 6;
    });

    doc.line(5, y, 75, y);

    // --- TOTALES
    y += 6;
    doc.text(`Subtotal: $${receipt.subtotal.toLocaleString()}`, 5, y);
    if(!receipt.taxesList.length){
      y += 4;
      doc.text(`Impuestos: $0`, 5, y);
    }
    receipt.taxesList.forEach(tax =>{
      y += 4;
      doc.text(`${tax.description}: $${tax.tax_amount.toLocaleString()}`, 5, y);
    })
    y += 4;
    doc.setFont("helvetica", "bold");
    doc.text(`TOTAL: $${receipt.total.toLocaleString()}`, 5, y);

    // --- MENSAJE FINAL
    doc.setFont("helvetica", "italic");
    doc.setFontSize(9);
    y += 10;
    doc.text(receipt.message || "", 40, y, { align: "center" });

    y += 10;
    doc.text("***", 40, y, { align: "center" });

    y += 4;
    doc.text("Powered by Ryo Solutions ©", 40, y, { align: "center" });

    // --- Guardar o abrir PDF
    //doc.save(`TCK_${receipt.receiptId}.pdf`);
    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  return (
    <Button type="primary" onClick={generateTicket}>
      Generar ticket
    </Button>
  );
};

export default ReceiptPDFPrint;
